<template>
  <div id="containAll">
    <SideBar />
    <Header />
    <Alert />
    <router-view
      class="content-wrap"
      :key="$route.fullPath"
      :main-color-obj="mainColorObj"
      :time="time"
      :trackList="trackList"
      @update:trackList="updateTrackList"
    />
    <!-- <div class="trackArea" v-if="trackData.length > 0">
      <transition-group name="fade" tag="div">
        <div
          class="alert alert-dismissible alert-info"
          v-for="item in trackData"
          :key="item.alertId"
        >
          <span>{{ item.name }} {{ item.msg }}</span>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click.prevent="setReadedflag(item.alertId)"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </transition-group>
    </div>-->
  </div>
</template>

<script>
// @ is an alias to /src

import "@/assets/js/lib/jquery.nanoscroller.min.js";
import SideBar from "@/views/SideBar";
import Header from "@/views/Header";
import Alert from "@/views/Alert";

export default {
  data() {
    return {
      mainColorObj: {
        poster: {
          color: "#ffc107",
          colorName: "warning"
        },
        card: {
          color: "#e6a1f2",
          colorName: "pink"
        },
        ink: {
          color: "#17a2b8",
          colorName: "info"
        },
        digit: {
          color: "#28a745",
          colorName: "success"
        }
      },
      time: {
        year: "",
        month: "",
        date: "",
        today: "",
        day: ""
      },
      trackList: [],
      trackMainData: [],
      timer: "",
      callDep: 0,
      lastCallTime: "",
      calledAry: []
    };
  },
  components: {
    SideBar,
    Header,
    Alert
  },
  created() {
    this.timerHandler();
    const vm = this;
    (async () => {
      await this.checkUser();
    })();
  },
  computed: {
    trackData() {
      return this.trackMainData;
    },
    user() {
      return this.$store.state.loginState.account
        ? this.$store.state.loginState
        : {};
    }
  },
  methods: {
    timerHandler() {
      this.time.date = new Date().getDate();
      this.time.month = new Date().getMonth() + 1;
      this.time.year = new Date().getFullYear();
      this.time.day = new Date().getDay();
      this.time.today = `${this.time.year}-${this.$formatTime(
        this.time.month
      )}-${this.$formatTime(this.time.date)}`;
    },
    checkUser() {
      if (!this.$store.state.loginState.account) {
        this.$router.push({ path: "/login" });
      }
    },
    updateTrackList(data) {
      this.trackList = data.split(",").map(el => el.split("@")[0]);
    },
    getTrackData() {
      $.ajax({
        url: "./php/main.php",
        type: "post",
        data: { function: "writeTrackData", tracker: this.User.userId }
      }).done(res => {
        const data = JSON.parse(res);
        this.trackMainData = data;
      });
    },
    setReadedflag(alertId) {
      clearInterval(this.timer);
      this.trackMainData = this.trackMainData.filter(
        el => el.alertId !== alertId
      );
      $.ajax({
        url: "./php/main.php",
        type: "post",
        data: { function: "setReadedflag", alertId: alertId }
      }).done(() => {
        this.timerOn();
      });
    },
    timerOn() {
      this.timer = setInterval(() => {
        this.getTrackData();
      }, 20000);
    }
  }
};

var webExamCount = function(dep) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "./php/call2.php",
      type: "post",
      data: {
        function: "callFn",
        fnCode: "webExamCount",
        dep: dep
      },
      error(err) {
        reject(err);
      }
    }).done(res => {
      resolve(res);
    });
  });
};
</script>

<style scope>
@import "../assets/css/lib/menubar/sidebar.css";
@import "../assets/css/lib/toastr/toastr.min.css";
@import "../assets/css/lib/font-awesome.min.css";
@import "../assets/css/lib/themify-icons.css";
@import "../assets/css/lib/owl.theme.default.min.css";
@import "../assets/css/lib/helper.css";
@import "../assets/css/style.css";
@import "../assets/main.css";

#containAll {
  position: relative;
}

.trackArea {
  position: fixed;
  width: 400px;
  bottom: 70px;
  right: 10px;
  z-index: 1100;
  padding: 15px 20px;
}

.fade-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(10px);
}
</style>

